const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (e) => reject(e));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

const toRadian = (deg) => (deg * Math.PI) / 180;

const rotateSize = (width, height, rotation) => {
  const r = toRadian(rotation);
  return {
    width: Math.abs(Math.cos(r) * width) + Math.abs(Math.sin(r) * height),
    height: Math.abs(Math.sin(r) * width) + Math.abs(Math.cos(r) * height),
  };
};

// Bakes crop, rotation and brightness/contrast into an 800x800 PNG blob.
export async function getProcessedImage(imageSrc, pixelCrop, rotation = 0, brightness = 100, contrast = 100) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const { width: bBoxWidth, height: bBoxHeight } = rotateSize(image.width, image.height, rotation);
  canvas.width = bBoxWidth;
  canvas.height = bBoxHeight;

  ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
  ctx.rotate(toRadian(rotation));
  ctx.translate(-image.width / 2, -image.height / 2);
  ctx.filter = `brightness(${brightness}%) contrast(${contrast}%)`;
  ctx.drawImage(image, 0, 0);

  const out = document.createElement("canvas");
  const outCtx = out.getContext("2d");
  out.width = 800;
  out.height = 800;
  outCtx.imageSmoothingEnabled = true;
  outCtx.imageSmoothingQuality = "high";
  outCtx.drawImage(
    canvas,
    pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
    0, 0, 800, 800,
  );

  return new Promise((resolve) => out.toBlob((blob) => resolve(blob), "image/png"));
}
